import { render, staticRenderFns } from "./recommendInfo.vue?vue&type=template&id=7793fe8e&"
import script from "./recommendInfo.vue?vue&type=script&lang=js&"
export * from "./recommendInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports